import { Grid, FormControl } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { converToDayjs, formatToString } from '_constants';
import { StyledFormLabel } from 'components/atoms';
import {
  BaseFieldProps,
  withGridItemCSS,
  withWrapperCSS,
} from 'components/organisms/forms/form-builder/types';
import { Dayjs } from 'dayjs';
import { noop } from 'lodash';
import React, { FC } from 'react';

export const LocalizedDatePicker: FC<
  BaseFieldProps<string> & withGridItemCSS & withWrapperCSS
> = ({
  disabled = false,
  error,
  fieldKey,
  gridItemCss,
  initValue = '',
  label = '',
  onChange = noop,
  labelCss,
  required = false,
  wrapperCss,
  xs = 12,
}) => {
  const [value, setValue] = React.useState<Dayjs | null>(converToDayjs(initValue));

  const dateChange = (newValue: Dayjs | null) => {
    setValue(newValue);
    if (newValue !== null) onChange(formatToString(newValue), fieldKey);
    else onChange('', fieldKey);
  };

  return (
    <Grid item xs={xs} style={gridItemCss}>
      <FormControl
        error={!!error}
        required={required}
        style={{ width: '100%', ...wrapperCss }}
      >
        <StyledFormLabel error={!!error} style={labelCss}>
          {label} {required ? '*' : null}
        </StyledFormLabel>
        <DatePicker
          value={value}
          disabled={disabled}
          onChange={(newValue) => dateChange(newValue)}
          disableFuture={true}
          slotProps={{
            textField: { inputProps: { 'data-testid': `field-${fieldKey}` } },
          }}
        />
      </FormControl>
    </Grid>
  );
};
